import * as React from 'react'
import { SVGProps } from 'react'

const SvgYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 38.3 27" {...props}>
    <path d="M38 5.8s-.4-2.6-1.6-3.8A5.5 5.5 0 0 0 32.6.4C27.2 0 19.2 0 19.2 0s-8 0-13.4.4A5.5 5.5 0 0 0 1.9 2C.8 3.2.4 5.8.4 5.8A58 58 0 0 0 0 12v2.9a58 58 0 0 0 .4 6.2s.4 2.6 1.5 3.8 3.4 1.5 4.2 1.6c3.1.3 13 .4 13 .4s8.1 0 13.4-.4a5.5 5.5 0 0 0 3.8-1.6c1.2-1.2 1.5-3.8 1.5-3.8a58.1 58.1 0 0 0 .4-6.2V12a58.1 58.1 0 0 0-.2-6.2zM15.2 18.5V7.7l10.4 5.4z" />
  </svg>
)

export default SvgYoutube
